import React, { useCallback, useState } from "react";
import { useFetchItem } from "../../../hooks/useFetchItem";
import { Price } from "../../../models/price";
import PeriodSwitcher from "./PeriodSwitcher";

export default function LeasePrice(props) {
  const { itemId, initialLeasePrice } = props;
  const [item] = useFetchItem(itemId);
  const [leasePrice, setLeasePrice] = useState();

  const handleSelectYear = useCallback(
    (price) => {
      setLeasePrice(price);
    }, [setLeasePrice]);

  return (
    <React.Fragment>
      <div className={'leasePrice'}>
        <div className={'leasePrice__title helperHover'}>
          <h3 className={'leasePrice__title__label'}>
            毎月の支払い額
          </h3>
          <div className={'userPrice'}>
            <span>
            販売価格:
              {item ? new Price(item.user_price).convert_by_base_unit(10000) : "---"}
              万円(税抜)
            </span>
          </div>
        </div>
        <p className={'leasePrice__price size-l'}>
          <span className={'leasePrice__price__num'}>
            {leasePrice ? leasePrice : initialLeasePrice}
          </span>
          <span className={'leasePrice__price__unit'}>
          円(税込)〜
          </span>
        </p>
      </div>
      <span className={'remark-font'}>※自動車税は含まれておりません。</span>
      {item && <PeriodSwitcher labelList={item.lease_price_list} handleSelectYear={handleSelectYear}/>}
    </React.Fragment>
  )
}
